<!-- The page's one H1, matching the one the server ships for crawlers (buildBlogListSeo) -->
<h1 class="sr-only" *ngIf="sections.length">Codigrate Blog: Color Theory, Palettes, Themes and Open Source</h1>

<div class="pl-page" *ngIf="sections.length; else emptyState">

  <!-- The Apps & Plugins hero band (owner 2026-10-12): the title, one line, the categories and the feeds -->
  <header class="pl-hero">
    <div class="pl-hero-inner">
      <p class="tools-title" aria-hidden="true">Blog</p>
      <p class="tools-subtitle">Notes on color, palettes and the places behind our themes</p>
      <!-- a chip per category, a jump to its box (owner 2026-10-12), the feeds on the line under them -->
      <nav class="pl-chips" aria-label="Blog categories">
        <a *ngFor="let section of sections" class="pl-chip" [attr.href]="'/blog?category=' + section.key"
           (click)="jumpTo( section.key, $event )">
          <span>{{ section.label }}</span>
        </a>
      </nav>
      <nav class="pl-chips bl-feeds" aria-label="Blog feeds">
        <a class="pl-chip" href="/blog/rss.xml" target="_blank" rel="noopener">
          <svg class="bl-feed" viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" fill="currentColor">
            <circle cx="6.18" cy="17.82" r="2.18"></circle>
            <path d="M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83C19.56 11.26 12.74 4.44 4 4.44z"></path>
            <path d="M4 10.1v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83C13.9 14.36 9.64 10.1 4 10.1z"></path>
          </svg>
          <span>RSS</span>
        </a>
        <a class="pl-chip" href="/blog/atom.xml" target="_blank" rel="noopener">
          <svg class="bl-feed" viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" fill="currentColor">
            <circle cx="6.18" cy="17.82" r="2.18"></circle>
            <path d="M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83C19.56 11.26 12.74 4.44 4 4.44z"></path>
            <path d="M4 10.1v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83C13.9 14.36 9.64 10.1 4 10.1z"></path>
          </svg>
          <span>Atom</span>
        </a>
      </nav>
    </div>
  </header>

  <!-- every post at once (owner 2026-10-12: more cards and smaller ones), a box per category as the home's wide
       boxes, lying on its side: the category at the left, its posts as small cards at the right, newest first -->
  <section *ngFor="let section of shownSections" class="bl-box" [id]="'cat-' + section.key" tabindex="-1">
    <header class="bl-head">
      <span class="bl-eyebrow"><img class="bl-eyebrow-logo" src="./assets/product-lines/tools/blog.svg" alt="" width="15" height="15"/>{{ section.eyebrow }}</span>
      <h2 class="bl-title">{{ section.label }}</h2>
      <p class="bl-lead">{{ section.lead }}</p>
      <!-- how much there is to read, as the home boxes' facts -->
      <ul class="bl-facts">
        <li>{{ section.posts.length }} {{ section.posts.length === 1 ? 'Post' : 'Posts' }}</li>
        <li>{{ section.minutes }} Min Read</li>
      </ul>
    </header>
    <div class="bl-grid">
      <a *ngFor="let post of section.posts; trackBy: trackPost" class="bl-card" [routerLink]="post.url">
        <span class="bl-cover">
          <img appImgFallback [src]="post.cover" [alt]="post.title" loading="lazy" decoding="async">
        </span>
        <span class="bl-card-title">{{ post.title }}</span>
        <span class="bl-meta">{{ post.dateLabel }} &middot; {{ post.readingTimeMinutes }} min read</span>
      </a>
    </div>
  </section>
</div>

<ng-template #emptyState>
  <div class="empty-state">
    <h1 class="empty-title">Our Blog Is Just Getting Started</h1>
    <p class="empty-text">
      Fresh writing on color, palettes, and the themes we build is on the way
    </p>
    <a routerLink="/themes" class="empty-cta">Browse Our Themes</a>
  </div>
</ng-template>
